import { helper } from '@ember/component/helper';

import { timeSeriesDate as tsd } from 'rise-ui/utils/time-series-date.js';

export default helper(function timeSeriesDatesHelper([ from, to, delimiter = ' - ' ]) {
  return tsd(from) + delimiter + tsd(to);
});
